// extracted by mini-css-extract-plugin
export default {"root":"WuSgxl0","marker":"ZQxn73M"};